import React from 'react';
import { StatusTag, type StatusTagProps } from '../Status/StatusTag';

/**
 * Статусы сущностей (заявка, маршрут, агрегаты) через единый {@link StatusTag}.
 * Не использовать для фин. обязательств / obligation — там свои теги.
 */
export const StatusCell: React.FC<StatusTagProps> = (props) => <StatusTag {...props} />;

export default StatusCell;
